<template>
    <transition name="faidin" v-if="popUpIsOpen">
        <div class="bag">
            <div class="popup">
                <div class="text">{{ text }}</div>
                <div class="form__btn">
                    <BtnOk @clickokay="clickOkay" />
                    <BtnCancel @clickcencel="clickcencel" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import BtnOk from "@/components/form/BtnOk.vue";
import BtnCancel from "@/components/form/BtnCancel.vue";

export default {
    components: {
        BtnOk,
        BtnCancel
    },

    props: {
        text: {
            type: String,
            require: true
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        //
    },

    data() {
        return {
            popUpIsOpen: this.isOpen
        };
    },

    methods: {
        clickOkay() {
            this.$emit("popupclickokay");
        },
        clickcencel() {
            this.popUpIsOpen = false;
            this.$emit("popupclickcencel");
        }
    },

    watch: {
        isOpen() {
            this.popUpIsOpen = this.isOpen;
        }
    }
};
</script>

<style lang="sass" scoped>
.bag
  +rgba($grey-d, 0.8)
  +pac(50%, 50%, fixed)
  width: 100%
  height: 100%
  display: flex
.popup
  background-color: $grey-l
  border: 1px solid $grey-d
  padding: 2% 5%;
  max-width: 500px
  margin: auto
.text
  text-align: center
.faidin-enter-active, .faidin-leave-active
  transition: transform 500ms, opacity 200ms
.faidin-enter, .faidin-leave-to
  opacity: 0
  transform: translate(-50%,-50%) scale(1.05)
</style>
